import _ from 'lodash';
import { connect } from 'react-redux';
import { get, update, add, send, publicGet, getEmailInfo, invalidate } from '../../modules/accounting/bulkInvoice';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let bulkInvoice;
	let bulkInvoiceId;

	if (ownProps.bulkInvoice) {
		bulkInvoice = ownProps.bulkInvoice;
	} else {
		bulkInvoiceId = (ownProps.bulkInvoiceId)
			? ownProps.bulkInvoiceId
			: _.get(ownProps, ['match', 'params', 'bulkInvoiceId']);
		bulkInvoice = _.get(state.maps, ['bulkInvoice', bulkInvoiceId]);
	}

	/** @namespace state.maps.bulkDelivery **/
	return {
		bulkInvoice,
		bulkCustomerMap : state.maps.bulkCustomer,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
		bulkFormulaMap : state.maps.bulkFormula,
		bulkDeliveryMap : state.maps.bulkDelivery,
		invoiceDocumentMap : state.maps.invoiceDocument,
		quickbooksCustomerMap : state.maps.quickbooksCustomer,
		quickbooksTermMap : state.maps.quickbooksTerm,
		dataDumpMap : state.maps.dataDump,
		bulkQuotedPriceMap : state.maps.bulkQuotedPrice,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getBulkInvoice : get,
	addBulkInvoice : add,
	updateBulkInvoice : update,
	sendBulkInvoice : send,
	publicGetBulkInvoice : publicGet,
	getBulkInvoiceEmailInfo : getEmailInfo,
	invalidateBulkInvoice : invalidate,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
